// [src/utils/iChing/data/sixtyFourGuaData.js] [2025-11-22 09:45:00]
// 功能：完整的六十四卦数据（含世爻、纳甲、六亲信息）及六神计算
// 目的：为排盘系统提供完整的卦象数据支持和六神计算功能

// 六十四卦完整数据
export const SIXTY_FOUR_GUA = {
    // 乾宫八卦（完整）
    "乾为天": {
        "code": "111111", "upper": "乾", "lower": "乾", "number": 1, "sequence": 1, "palace": "乾",
        "nature": "乾健", "attribute": "纯阳", "gua_ci": "元亨利贞",
        "shi_yao": 6, "shi_type": "本宫",
        "stems": ["甲", "甲", "甲", "壬", "壬", "壬"],
        "branches": ["子", "寅", "辰", "午", "申", "戌"],
        "liu_qin": ["子孙", "妻财", "父母", "官鬼", "兄弟", "父母"]
    },
    "天风姤": {
        "code": "011111", "upper": "乾", "lower": "巽", "number": 44, "sequence": 2, "palace": "乾",
        "nature": "天下有风", "attribute": "消息卦", "gua_ci": "女壮，勿用取女",
        "shi_yao": 1, "shi_type": "一世",
        "stems": ["辛", "辛", "辛", "壬", "壬", "壬"],
        "branches": ["丑", "亥", "酉", "午", "申", "戌"],
        "liu_qin": ["父母", "子孙", "兄弟", "官鬼", "兄弟", "父母"]
    },
    "天山遁": {
        "code": "001111", "upper": "乾", "lower": "艮", "number": 33, "sequence": 3, "palace": "乾",
        "nature": "天下有山", "attribute": "退避", "gua_ci": "亨，小利贞",
        "shi_yao": 2, "shi_type": "二世",
        "stems": ["丙", "丙", "丙", "壬", "壬", "壬"],
        "branches": ["辰", "午", "申", "午", "申", "戌"],
        "liu_qin": ["父母", "官鬼", "兄弟", "官鬼", "兄弟", "父母"]
    },
    "天地否": {
        "code": "000111", "upper": "乾", "lower": "坤", "number": 12, "sequence": 4, "palace": "乾",
        "nature": "天地不交", "attribute": "闭塞", "gua_ci": "否之匪人，不利君子贞",
        "shi_yao": 3, "shi_type": "三世",
        "stems": ["乙", "乙", "乙", "壬", "壬", "壬"],
        "branches": ["未", "巳", "卯", "午", "申", "戌"],
        "liu_qin": ["父母", "官鬼", "妻财", "官鬼", "兄弟", "父母"]
    },
    "风地观": {
        "code": "000011", "upper": "巽", "lower": "坤", "number": 20, "sequence": 5, "palace": "乾",
        "nature": "风行地上", "attribute": "观察", "gua_ci": "盥而不荐，有孚颙若",
        "shi_yao": 4, "shi_type": "四世",
        "stems": ["乙", "乙", "乙", "辛", "辛", "辛"],
        "branches": ["未", "巳", "卯", "未", "巳", "卯"],
        "liu_qin": ["父母", "官鬼", "妻财", "父母", "官鬼", "妻财"]
    },
    "山地剥": {
        "code": "000001", "upper": "艮", "lower": "坤", "number": 23, "sequence": 6, "palace": "乾",
        "nature": "山附于地", "attribute": "剥落", "gua_ci": "不利有攸往",
        "shi_yao": 5, "shi_type": "五世",
        "stems": ["乙", "乙", "乙", "丙", "丙", "丙"],
        "branches": ["未", "巳", "卯", "戌", "子", "寅"],
        "liu_qin": ["父母", "官鬼", "妻财", "父母", "子孙", "妻财"]
    },
    "火地晋": {
        "code": "000101", "upper": "离", "lower": "坤", "number": 35, "sequence": 7, "palace": "乾",
        "nature": "明出地上", "attribute": "前进", "gua_ci": "康侯用锡马蕃庶，昼日三接",
        "shi_yao": 4, "shi_type": "游魂",
        "stems": ["乙", "乙", "乙", "己", "己", "己"],
        "branches": ["未", "巳", "卯", "酉", "未", "巳"],
        "liu_qin": ["父母", "官鬼", "妻财", "兄弟", "父母", "官鬼"]
    },
    "火天大有": {
        "code": "111101", "upper": "离", "lower": "乾", "number": 14, "sequence": 8, "palace": "乾",
        "nature": "火在天上", "attribute": "丰盛", "gua_ci": "元亨",
        "shi_yao": 3, "shi_type": "归魂",
        "stems": ["甲", "甲", "甲", "己", "己", "己"],
        "branches": ["子", "寅", "辰", "酉", "未", "巳"],
        "liu_qin": ["子孙", "妻财", "父母", "兄弟", "父母", "官鬼"]
    },

    // 兑宫八卦（完整）
    "兑为泽": {
        "code": "110110", "upper": "兑", "lower": "兑", "number": 58, "sequence": 9, "palace": "兑",
        "nature": "丽泽", "attribute": "悦乐", "gua_ci": "亨，利贞",
        "shi_yao": 6, "shi_type": "本宫",
        "stems": ["丁", "丁", "丁", "丁", "丁", "丁"],
        "branches": ["巳", "卯", "丑", "亥", "酉", "未"],
        "liu_qin": ["官鬼", "妻财", "父母", "子孙", "兄弟", "父母"]
    },
    "泽水困": {
        "code": "010110", "upper": "兑", "lower": "坎", "number": 47, "sequence": 10, "palace": "兑",
        "nature": "泽无水", "attribute": "困顿", "gua_ci": "亨，贞，大人吉，无咎",
        "shi_yao": 1, "shi_type": "一世",
        "stems": ["戊", "戊", "戊", "丁", "丁", "丁"],
        "branches": ["寅", "辰", "午", "亥", "酉", "未"],
        "liu_qin": ["妻财", "父母", "官鬼", "子孙", "兄弟", "父母"]
    },
    "泽地萃": {
        "code": "000110", "upper": "兑", "lower": "坤", "number": 45, "sequence": 11, "palace": "兑",
        "nature": "泽于地", "attribute": "聚集", "gua_ci": "亨，王假有庙",
        "shi_yao": 2, "shi_type": "二世",
        "stems": ["乙", "乙", "乙", "丁", "丁", "丁"],
        "branches": ["未", "巳", "卯", "亥", "酉", "未"],
        "liu_qin": ["父母", "官鬼", "妻财", "子孙", "兄弟", "父母"]
    },
    "泽山咸": {
        "code": "001110", "upper": "兑", "lower": "艮", "number": 31, "sequence": 12, "palace": "兑",
        "nature": "山泽通气", "attribute": "感应", "gua_ci": "亨，利贞，取女吉",
        "shi_yao": 3, "shi_type": "三世",
        "stems": ["丙", "丙", "丙", "丁", "丁", "丁"],
        "branches": ["辰", "午", "申", "亥", "酉", "未"],
        "liu_qin": ["父母", "官鬼", "兄弟", "子孙", "兄弟", "父母"]
    },
    "水山蹇": {
        "code": "001010", "upper": "坎", "lower": "艮", "number": 39, "sequence": 13, "palace": "兑",
        "nature": "山上有水", "attribute": "艰难", "gua_ci": "利西南，不利东北",
        "shi_yao": 4, "shi_type": "四世",
        "stems": ["丙", "丙", "丙", "戊", "戊", "戊"],
        "branches": ["辰", "午", "申", "申", "戌", "子"],
        "liu_qin": ["父母", "官鬼", "兄弟", "兄弟", "父母", "子孙"]
    },
    "地山谦": {
        "code": "001000", "upper": "坤", "lower": "艮", "number": 15, "sequence": 14, "palace": "兑",
        "nature": "地中有山", "attribute": "谦虚", "gua_ci": "亨，君子有终",
        "shi_yao": 5, "shi_type": "五世",
        "stems": ["丙", "丙", "丙", "癸", "癸", "癸"],
        "branches": ["辰", "午", "申", "丑", "亥", "酉"],
        "liu_qin": ["父母", "官鬼", "兄弟", "父母", "子孙", "兄弟"]
    },
    "雷山小过": {
        "code": "001100", "upper": "震", "lower": "艮", "number": 62, "sequence": 15, "palace": "兑",
        "nature": "山上有雷", "attribute": "小有过失", "gua_ci": "亨，利贞",
        "shi_yao": 4, "shi_type": "游魂",
        "stems": ["丙", "丙", "丙", "庚", "庚", "庚"],
        "branches": ["辰", "午", "申", "午", "申", "戌"],
        "liu_qin": ["父母", "官鬼", "兄弟", "官鬼", "兄弟", "父母"]
    },
    "雷泽归妹": {
        "code": "110100", "upper": "震", "lower": "兑", "number": 54, "sequence": 16, "palace": "兑",
        "nature": "泽上有雷", "attribute": "婚嫁", "gua_ci": "征凶，无攸利",
        "shi_yao": 3, "shi_type": "归魂",
        "stems": ["丁", "丁", "丁", "庚", "庚", "庚"],
        "branches": ["巳", "卯", "丑", "午", "申", "戌"],
        "liu_qin": ["官鬼", "妻财", "父母", "官鬼", "兄弟", "父母"]
    },

    // 离宫八卦（完整）
    "离为火": {
        "code": "101101", "upper": "离", "lower": "离", "number": 30, "sequence": 17, "palace": "离",
        "nature": "明两作", "attribute": "附丽", "gua_ci": "利贞，亨",
        "shi_yao": 6, "shi_type": "本宫",
        "stems": ["己", "己", "己", "己", "己", "己"],
        "branches": ["卯", "丑", "亥", "酉", "未", "巳"],
        "liu_qin": ["父母", "妻财", "官鬼", "妻财", "子孙", "兄弟"]
    },
    "火山旅": {
        "code": "001101", "upper": "离", "lower": "艮", "number": 56, "sequence": 18, "palace": "离",
        "nature": "山上有火", "attribute": "旅行", "gua_ci": "小亨，旅贞吉",
        "shi_yao": 1, "shi_type": "一世",
        "stems": ["丙", "丙", "丙", "己", "己", "己"],
        "branches": ["辰", "午", "申", "酉", "未", "巳"],
        "liu_qin": ["子孙", "兄弟", "妻财", "妻财", "子孙", "兄弟"]
    },
    "火风鼎": {
        "code": "011101", "upper": "离", "lower": "巽", "number": 50, "sequence": 19, "palace": "离",
        "nature": "木上有火", "attribute": "鼎新", "gua_ci": "元吉，亨",
        "shi_yao": 2, "shi_type": "二世",
        "stems": ["辛", "辛", "辛", "己", "己", "己"],
        "branches": ["丑", "亥", "酉", "酉", "未", "巳"],
        "liu_qin": ["子水", "官鬼", "妻财", "妻财", "子孙", "兄弟"]
    },
    "火水未济": {
        "code": "010101", "upper": "离", "lower": "坎", "number": 64, "sequence": 20, "palace": "离",
        "nature": "火在水上", "attribute": "未完成", "gua_ci": "亨，小狐汔济",
        "shi_yao": 3, "shi_type": "三世",
        "stems": ["戊", "戊", "戊", "己", "己", "己"],
        "branches": ["寅", "辰", "午", "酉", "未", "巳"],
        "liu_qin": ["父母", "子孙", "兄弟", "妻财", "子孙", "兄弟"]
    },
    "山水蒙": {
        "code": "010001", "upper": "艮", "lower": "坎", "number": 4, "sequence": 21, "palace": "离",
        "nature": "山下出泉", "attribute": "蒙昧", "gua_ci": "亨。匪我求童蒙，童蒙求我",
        "shi_yao": 4, "shi_type": "四世",
        "stems": ["戊", "戊", "戊", "丙", "丙", "丙"],
        "branches": ["寅", "辰", "午", "戌", "子", "寅"],
        "liu_qin": ["父母", "子孙", "兄弟", "子孙", "官鬼", "父母"]
    },
    "风水涣": {
        "code": "010011", "upper": "巽", "lower": "坎", "number": 59, "sequence": 22, "palace": "离",
        "nature": "风行水上", "attribute": "涣散", "gua_ci": "亨。王假有庙",
        "shi_yao": 5, "shi_type": "五世",
        "stems": ["戊", "戊", "戊", "辛", "辛", "辛"],
        "branches": ["寅", "辰", "午", "未", "巳", "卯"],
        "liu_qin": ["父母", "子孙", "兄弟", "子孙", "兄弟", "父母"]
    },
    "天水讼": {
        "code": "010111", "upper": "乾", "lower": "坎", "number": 6, "sequence": 23, "palace": "离",
        "nature": "天与水违行", "attribute": "争讼", "gua_ci": "有孚，窒惕，中吉",
        "shi_yao": 4, "shi_type": "游魂",
        "stems": ["戊", "戊", "戊", "壬", "壬", "壬"],
        "branches": ["寅", "辰", "午", "午", "申", "戌"],
        "liu_qin": ["父母", "子孙", "兄弟", "兄弟", "妻财", "子孙"]
    },
    "天火同人": {
        "code": "101111", "upper": "乾", "lower": "离", "number": 13, "sequence": 24, "palace": "离",
        "nature": "天与火", "attribute": "同心", "gua_ci": "同人于野，亨",
        "shi_yao": 3, "shi_type": "归魂",
        "stems": ["己", "己", "己", "壬", "壬", "壬"],
        "branches": ["卯", "丑", "亥", "午", "申", "戌"],
        "liu_qin": ["父母", "子孙", "官鬼", "兄弟", "妻财", "子孙"]
    },

    // 震宫八卦（完整）
    "震为雷": {
        "code": "100100", "upper": "震", "lower": "震", "number": 51, "sequence": 25, "palace": "震",
        "nature": "洊雷", "attribute": "震动", "gua_ci": "亨，震来虩虩，笑言哑哑",
        "shi_yao": 6, "shi_type": "本宫",
        "stems": ["庚", "庚", "庚", "庚", "庚", "庚"],
        "branches": ["子", "寅", "辰", "午", "申", "戌"],
        "liu_qin": ["父母", "兄弟", "妻财", "子孙", "官鬼", "妻财"]
    },
    "雷地豫": {
        "code": "000100", "upper": "震", "lower": "坤", "number": 16, "sequence": 26, "palace": "震",
        "nature": "雷出地奋", "attribute": "愉悦", "gua_ci": "利建侯行师",
        "shi_yao": 1, "shi_type": "一世",
        "stems": ["乙", "乙", "乙", "庚", "庚", "庚"],
        "branches": ["未", "巳", "卯", "午", "申", "戌"],
        "liu_qin": ["妻财", "子孙", "兄弟", "子孙", "官鬼", "妻财"]
    },
    "雷水解": {
        "code": "010100", "upper": "震", "lower": "坎", "number": 40, "sequence": 27, "palace": "震",
        "nature": "雷雨作", "attribute": "解除", "gua_ci": "利西南",
        "shi_yao": 2, "shi_type": "二世",
        "stems": ["戊", "戊", "戊", "庚", "庚", "庚"],
        "branches": ["寅", "辰", "午", "午", "申", "戌"],
        "liu_qin": ["兄弟", "妻财", "子孙", "子孙", "官鬼", "妻财"]
    },
    "雷风恒": {
        "code": "011100", "upper": "震", "lower": "巽", "number": 32, "sequence": 28, "palace": "震",
        "nature": "雷风相与", "attribute": "恒久", "gua_ci": "亨，无咎，利贞",
        "shi_yao": 3, "shi_type": "三世",
        "stems": ["辛", "辛", "辛", "庚", "庚", "庚"],
        "branches": ["丑", "亥", "酉", "午", "申", "戌"],
        "liu_qin": ["妻财", "父母", "官鬼", "子孙", "官鬼", "妻财"]
    },
    "地风升": {
        "code": "011000", "upper": "坤", "lower": "巽", "number": 46, "sequence": 29, "palace": "震",
        "nature": "地中生木", "attribute": "上升", "gua_ci": "元亨，用见大人",
        "shi_yao": 4, "shi_type": "四世",
        "stems": ["辛", "辛", "辛", "癸", "癸", "癸"],
        "branches": ["丑", "亥", "酉", "丑", "亥", "酉"],
        "liu_qin": ["妻财", "父母", "官鬼", "妻财", "父母", "官鬼"]
    },
    "水风井": {
        "code": "011010", "upper": "坎", "lower": "巽", "number": 48, "sequence": 30, "palace": "震",
        "nature": "木上有水", "attribute": "水井", "gua_ci": "改邑不改井",
        "shi_yao": 5, "shi_type": "五世",
        "stems": ["辛", "辛", "辛", "戊", "戊", "戊"],
        "branches": ["丑", "亥", "酉", "申", "戌", "子"],
        "liu_qin": ["妻财", "父母", "官鬼", "官鬼", "妻财", "父母"]
    },
    "泽风大过": {
        "code": "011110", "upper": "兑", "lower": "巽", "number": 28, "sequence": 31, "palace": "震",
        "nature": "泽灭木", "attribute": "过度", "gua_ci": "栋桡，利有攸往",
        "shi_yao": 4, "shi_type": "游魂",
        "stems": ["辛", "辛", "辛", "丁", "丁", "丁"],
        "branches": ["丑", "亥", "酉", "亥", "酉", "未"],
        "liu_qin": ["妻财", "父母", "官鬼", "父母", "官鬼", "妻财"]
    },
    "泽雷随": {
        "code": "100110", "upper": "兑", "lower": "震", "number": 17, "sequence": 32, "palace": "震",
        "nature": "泽中有雷", "attribute": "随从", "gua_ci": "元亨利贞，无咎",
        "shi_yao": 3, "shi_type": "归魂",
        "stems": ["庚", "庚", "庚", "丁", "丁", "丁"],
        "branches": ["子", "寅", "辰", "亥", "酉", "未"],
        "liu_qin": ["父母", "兄弟", "妻财", "父母", "官鬼", "妻财"]
    },

    // 巽宫八卦（完整）
    "巽为风": {
        "code": "011011", "upper": "巽", "lower": "巽", "number": 57, "sequence": 33, "palace": "巽",
        "nature": "随风", "attribute": "顺从", "gua_ci": "小亨，利有攸往，利见大人",
        "shi_yao": 6, "shi_type": "本宫",
        "stems": ["辛", "辛", "辛", "辛", "辛", "辛"],
        "branches": ["丑", "亥", "酉", "未", "巳", "卯"],
        "liu_qin": ["妻财", "父母", "官鬼", "妻财", "子孙", "兄弟"]
    },
    "风天小畜": {
        "code": "111011", "upper": "巽", "lower": "乾", "number": 9, "sequence": 34, "palace": "巽",
        "nature": "风行天上", "attribute": "小积", "gua_ci": "亨。密云不雨",
        "shi_yao": 1, "shi_type": "一世",
        "stems": ["甲", "甲", "甲", "辛", "辛", "辛"],
        "branches": ["子", "寅", "辰", "未", "巳", "卯"],
        "liu_qin": ["父母", "兄弟", "妻财", "妻财", "子孙", "兄弟"]
    },
    "风火家人": {
        "code": "101011", "upper": "巽", "lower": "离", "number": 37, "sequence": 35, "palace": "巽",
        "nature": "风自火出", "attribute": "家庭", "gua_ci": "利女贞",
        "shi_yao": 2, "shi_type": "二世",
        "stems": ["己", "己", "己", "辛", "辛", "辛"],
        "branches": ["卯", "丑", "亥", "未", "巳", "卯"],
        "liu_qin": ["兄弟", "妻财", "父母", "妻财", "子孙", "兄弟"]
    },
    "风雷益": {
        "code": "100011", "upper": "巽", "lower": "震", "number": 42, "sequence": 36, "palace": "巽",
        "nature": "风雷相益", "attribute": "增益", "gua_ci": "利有攸往，利涉大川",
        "shi_yao": 3, "shi_type": "三世",
        "stems": ["庚", "庚", "庚", "辛", "辛", "辛"],
        "branches": ["子", "寅", "辰", "未", "巳", "卯"],
        "liu_qin": ["父母", "兄弟", "妻财", "妻财", "子孙", "兄弟"]
    },
    "天雷无妄": {
        "code": "100111", "upper": "乾", "lower": "震", "number": 25, "sequence": 37, "palace": "巽",
        "nature": "天下雷行", "attribute": "无妄", "gua_ci": "元亨利贞",
        "shi_yao": 4, "shi_type": "四世",
        "stems": ["庚", "庚", "庚", "壬", "壬", "壬"],
        "branches": ["子", "寅", "辰", "午", "申", "戌"],
        "liu_qin": ["父母", "兄弟", "妻财", "子孙", "官鬼", "妻财"]
    },
    "火雷噬嗑": {
        "code": "100101", "upper": "离", "lower": "震", "number": 21, "sequence": 38, "palace": "巽",
        "nature": "电雷", "attribute": "咬合", "gua_ci": "亨，利用狱",
        "shi_yao": 5, "shi_type": "五世",
        "stems": ["庚", "庚", "庚", "己", "己", "己"],
        "branches": ["子", "寅", "辰", "酉", "未", "巳"],
        "liu_qin": ["父母", "兄弟", "妻财", "官鬼", "妻财", "子孙"]
    },
    "山雷颐": {
        "code": "100001", "upper": "艮", "lower": "震", "number": 27, "sequence": 39, "palace": "巽",
        "nature": "山下有雷", "attribute": "颐养", "gua_ci": "贞吉",
        "shi_yao": 4, "shi_type": "游魂",
        "stems": ["庚", "庚", "庚", "丙", "丙", "丙"],
        "branches": ["子", "寅", "辰", "戌", "子", "寅"],
        "liu_qin": ["父母", "兄弟", "妻财", "妻财", "父母", "兄弟"]
    },
    "山风蛊": {
        "code": "011001", "upper": "艮", "lower": "巽", "number": 18, "sequence": 40, "palace": "巽",
        "nature": "山下有风", "attribute": "蛊惑", "gua_ci": "元亨，利涉大川",
        "shi_yao": 3, "shi_type": "归魂",
        "stems": ["辛", "辛", "辛", "丙", "丙", "丙"],
        "branches": ["丑", "亥", "酉", "戌", "子", "寅"],
        "liu_qin": ["妻财", "父母", "官鬼", "妻财", "父母", "兄弟"]
    },

    // 坎宫八卦（完整）
    "坎为水": {
        "code": "010010", "upper": "坎", "lower": "坎", "number": 29, "sequence": 41, "palace": "坎",
        "nature": "水洊至", "attribute": "险陷", "gua_ci": "习坎，有孚维心，亨",
        "shi_yao": 6, "shi_type": "本宫",
        "stems": ["戊", "戊", "戊", "戊", "戊", "戊"],
        "branches": ["寅", "辰", "午", "申", "戌", "子"],
        "liu_qin": ["子孙", "官鬼", "妻财", "父母", "官鬼", "兄弟"]
    },
    "水泽节": {
        "code": "110010", "upper": "坎", "lower": "兑", "number": 60, "sequence": 42, "palace": "坎",
        "nature": "泽上有水", "attribute": "节制", "gua_ci": "亨。苦节不可贞",
        "shi_yao": 1, "shi_type": "一世",
        "stems": ["丁", "丁", "丁", "戊", "戊", "戊"],
        "branches": ["巳", "卯", "丑", "申", "戌", "子"],
        "liu_qin": ["妻财", "子孙", "官鬼", "父母", "官鬼", "兄弟"]
    },
    "水雷屯": {
        "code": "100010", "upper": "坎", "lower": "震", "number": 3, "sequence": 43, "palace": "坎",
        "nature": "云雷屯", "attribute": "初生", "gua_ci": "元亨利贞",
        "shi_yao": 2, "shi_type": "二世",
        "stems": ["庚", "庚", "庚", "戊", "戊", "戊"],
        "branches": ["子", "寅", "辰", "申", "戌", "子"],
        "liu_qin": ["兄弟", "子孙", "官鬼", "父母", "官鬼", "兄弟"]
    },
    "水火既济": {
        "code": "101010", "upper": "坎", "lower": "离", "number": 63, "sequence": 44, "palace": "坎",
        "nature": "水在火上", "attribute": "完成", "gua_ci": "亨小，利贞",
        "shi_yao": 3, "shi_type": "三世",
        "stems": ["己", "己", "己", "戊", "戊", "戊"],
        "branches": ["卯", "丑", "亥", "申", "戌", "子"],
        "liu_qin": ["子孙", "官鬼", "兄弟", "父母", "官鬼", "兄弟"]
    },
    "泽火革": {
        "code": "101110", "upper": "兑", "lower": "离", "number": 49, "sequence": 45, "palace": "坎",
        "nature": "泽中有火", "attribute": "变革", "gua_ci": "己日乃孚，元亨利贞",
        "shi_yao": 4, "shi_type": "四世",
        "stems": ["己", "己", "己", "丁", "丁", "丁"],
        "branches": ["卯", "丑", "亥", "亥", "酉", "未"],
        "liu_qin": ["子孙", "官鬼", "兄弟", "兄弟", "父母", "官鬼"]
    },
    "雷火丰": {
        "code": "101100", "upper": "震", "lower": "离", "number": 55, "sequence": 46, "palace": "坎",
        "nature": "雷电皆至", "attribute": "丰盛", "gua_ci": "亨，王假之",
        "shi_yao": 5, "shi_type": "五世",
        "stems": ["己", "己", "己", "庚", "庚", "庚"],
        "branches": ["卯", "丑", "亥", "午", "申", "戌"],
        "liu_qin": ["子孙", "官鬼", "兄弟", "妻财", "父母", "官鬼"]
    },
    "地火明夷": {
        "code": "101000", "upper": "坤", "lower": "离", "number": 36, "sequence": 47, "palace": "坎",
        "nature": "明入地中", "attribute": "光明受伤", "gua_ci": "利艰贞",
        "shi_yao": 4, "shi_type": "游魂",
        "stems": ["己", "己", "己", "癸", "癸", "癸"],
        "branches": ["卯", "丑", "亥", "丑", "亥", "酉"],
        "liu_qin": ["子孙", "官鬼", "兄弟", "官鬼", "兄弟", "父母"]
    },
    "地水师": {
        "code": "010000", "upper": "坤", "lower": "坎", "number": 7, "sequence": 48, "palace": "坎",
        "nature": "地中有水", "attribute": "师旅", "gua_ci": "贞，丈人吉",
        "shi_yao": 3, "shi_type": "归魂",
        "stems": ["戊", "戊", "戊", "癸", "癸", "癸"],
        "branches": ["寅", "辰", "午", "丑", "亥", "酉"],
        "liu_qin": ["子孙", "官鬼", "妻财", "官鬼", "兄弟", "父母"]
    },

    // 艮宫八卦（完整）
    "艮为山": {
        "code": "001001", "upper": "艮", "lower": "艮", "number": 52, "sequence": 49, "palace": "艮",
        "nature": "兼山", "attribute": "静止", "gua_ci": "艮其背，不获其身",
        "shi_yao": 6, "shi_type": "本宫",
        "stems": ["丙", "丙", "丙", "丙", "丙", "丙"],
        "branches": ["辰", "午", "申", "戌", "子", "寅"],
        "liu_qin": ["兄弟", "父母", "子孙", "兄弟", "妻财", "官鬼"]
    },
    "山火贲": {
        "code": "101001", "upper": "艮", "lower": "离", "number": 22, "sequence": 50, "palace": "艮",
        "nature": "山下有火", "attribute": "装饰", "gua_ci": "亨。小利有攸往",
        "shi_yao": 1, "shi_type": "一世",
        "stems": ["己", "己", "己", "丙", "丙", "丙"],
        "branches": ["卯", "丑", "亥", "戌", "子", "寅"],
        "liu_qin": ["官鬼", "兄弟", "妻财", "兄弟", "妻财", "官鬼"]
    },
    "山天大畜": {
        "code": "111001", "upper": "艮", "lower": "乾", "number": 26, "sequence": 51, "palace": "艮",
        "nature": "天在山中", "attribute": "大积蓄", "gua_ci": "利贞",
        "shi_yao": 2, "shi_type": "二世",
        "stems": ["甲", "甲", "甲", "丙", "丙", "丙"],
        "branches": ["子", "寅", "辰", "戌", "子", "寅"],
        "liu_qin": ["妻财", "官鬼", "兄弟", "兄弟", "妻财", "官鬼"]
    },
    "山泽损": {
        "code": "110001", "upper": "艮", "lower": "兑", "number": 41, "sequence": 52, "palace": "艮",
        "nature": "山下有泽", "attribute": "减损", "gua_ci": "有孚，元吉",
        "shi_yao": 3, "shi_type": "三世",
        "stems": ["丁", "丁", "丁", "丙", "丙", "丙"],
        "branches": ["巳", "卯", "丑", "戌", "子", "寅"],
        "liu_qin": ["父母", "官鬼", "兄弟", "兄弟", "妻财", "官鬼"]
    },
    "火泽睽": {
        "code": "110101", "upper": "离", "lower": "兑", "number": 38, "sequence": 53, "palace": "艮",
        "nature": "上火下泽", "attribute": "乖离", "gua_ci": "小事吉",
        "shi_yao": 4, "shi_type": "四世",
        "stems": ["丁", "丁", "丁", "己", "己", "己"],
        "branches": ["巳", "卯", "丑", "酉", "未", "巳"],
        "liu_qin": ["父母", "官鬼", "兄弟", "子水", "兄弟", "父母"]
    },
    "天泽履": {
        "code": "110111", "upper": "乾", "lower": "兑", "number": 10, "sequence": 54, "palace": "艮",
        "nature": "上天下泽", "attribute": "履行", "gua_ci": "履虎尾，不咥人",
        "shi_yao": 5, "shi_type": "五世",
        "stems": ["丁", "丁", "丁", "壬", "壬", "壬"],
        "branches": ["巳", "卯", "丑", "午", "申", "戌"],
        "liu_qin": ["父母", "官鬼", "兄弟", "父母", "子孙", "兄弟"]
    },
    "风泽中孚": {
        "code": "110011", "upper": "巽", "lower": "兑", "number": 61, "sequence": 55, "palace": "艮",
        "nature": "泽上有风", "attribute": "诚信", "gua_ci": "豚鱼吉",
        "shi_yao": 4, "shi_type": "游魂",
        "stems": ["丁", "丁", "丁", "辛", "辛", "辛"],
        "branches": ["巳", "卯", "丑", "未", "巳", "卯"],
        "liu_qin": ["父母", "官鬼", "兄弟", "兄弟", "父母", "官鬼"]
    },
    "风山渐": {
        "code": "001011", "upper": "巽", "lower": "艮", "number": 53, "sequence": 56, "palace": "艮",
        "nature": "山上有木", "attribute": "渐进", "gua_ci": "女归吉，利贞",
        "shi_yao": 3, "shi_type": "归魂",
        "stems": ["丙", "丙", "丙", "辛", "辛", "辛"],
        "branches": ["辰", "午", "申", "未", "巳", "卯"],
        "liu_qin": ["兄弟", "父母", "子孙", "兄弟", "父母", "官鬼"]
    },

    // 坤宫八卦（完整）
    "坤为地": {
        "code": "000000", "upper": "坤", "lower": "坤", "number": 2, "sequence": 57, "palace": "坤",
        "nature": "地势坤", "attribute": "柔顺", "gua_ci": "元亨，利牝马之贞",
        "shi_yao": 6, "shi_type": "本宫",
        "stems": ["乙", "乙", "乙", "癸", "癸", "癸"],
        "branches": ["未", "巳", "卯", "丑", "亥", "酉"],
        "liu_qin": ["兄弟", "父母", "官鬼", "兄弟", "妻财", "子孙"]
    },
    "地雷复": {
        "code": "100000", "upper": "坤", "lower": "震", "number": 24, "sequence": 58, "palace": "坤",
        "nature": "雷在地中", "attribute": "回复", "gua_ci": "亨。出入无疾",
        "shi_yao": 1, "shi_type": "一世",
        "stems": ["庚", "庚", "庚", "癸", "癸", "癸"],
        "branches": ["子", "寅", "辰", "丑", "亥", "酉"],
        "liu_qin": ["妻财", "官鬼", "兄弟", "兄弟", "妻财", "子孙"]
    },
    "地泽临": {
        "code": "110000", "upper": "坤", "lower": "兑", "number": 19, "sequence": 59, "palace": "坤",
        "nature": "泽上有地", "attribute": "临察", "gua_ci": "元亨利贞",
        "shi_yao": 2, "shi_type": "二世",
        "stems": ["丁", "丁", "丁", "癸", "癸", "癸"],
        "branches": ["巳", "卯", "丑", "丑", "亥", "酉"],
        "liu_qin": ["父母", "官鬼", "兄弟", "兄弟", "妻财", "子孙"]
    },
    "地天泰": {
        "code": "111000", "upper": "坤", "lower": "乾", "number": 11, "sequence": 60, "palace": "坤",
        "nature": "天地交", "attribute": "通达", "gua_ci": "小往大来，吉亨",
        "shi_yao": 3, "shi_type": "三世",
        "stems": ["甲", "甲", "甲", "癸", "癸", "癸"],
        "branches": ["子", "寅", "辰", "丑", "亥", "酉"],
        "liu_qin": ["妻财", "官鬼", "兄弟", "兄弟", "妻财", "子孙"]
    },
    "雷天大壮": {
        "code": "111100", "upper": "震", "lower": "乾", "number": 34, "sequence": 61, "palace": "坤",
        "nature": "雷在天上", "attribute": "强壮", "gua_ci": "利贞",
        "shi_yao": 4, "shi_type": "四世",
        "stems": ["甲", "甲", "甲", "庚", "庚", "庚"],
        "branches": ["子", "寅", "辰", "午", "申", "戌"],
        "liu_qin": ["妻财", "官鬼", "兄弟", "父母", "子孙", "兄弟"]
    },
    "泽天夬": {
        "code": "111110", "upper": "兑", "lower": "乾", "number": 43, "sequence": 62, "palace": "坤",
        "nature": "泽上于天", "attribute": "决断", "gua_ci": "扬于王庭",
        "shi_yao": 5, "shi_type": "五世",
        "stems": ["甲", "甲", "甲", "丁", "丁", "丁"],
        "branches": ["子", "寅", "辰", "亥", "酉", "未"],
        "liu_qin": ["妻财", "官鬼", "兄弟", "妻财", "子孙", "兄弟"]
    },
    "水天需": {
        "code": "111010", "upper": "坎", "lower": "乾", "number": 5, "sequence": 63, "palace": "坤",
        "nature": "云上于天", "attribute": "等待", "gua_ci": "有孚，光亨",
        "shi_yao": 4, "shi_type": "游魂",
        "stems": ["甲", "甲", "甲", "戊", "戊", "戊"],
        "branches": ["子", "寅", "辰", "申", "戌", "子"],
        "liu_qin": ["妻财", "官鬼", "兄弟", "子孙", "兄弟", "妻财"]
    },
    "水地比": {
        "code": "000010", "upper": "坎", "lower": "坤", "number": 8, "sequence": 64, "palace": "坤",
        "nature": "地上有水", "attribute": "亲比", "gua_ci": "吉。原筮元永贞",
        "shi_yao": 3, "shi_type": "归魂",
        "stems": ["乙", "乙", "乙", "戊", "戊", "戊"],
        "branches": ["未", "巳", "卯", "申", "戌", "子"],
        "liu_qin": ["兄弟", "父母", "官鬼", "子孙", "兄弟", "妻财"]
    }
}

// 六十四卦卦序列表（按传统卦序）
export const GUA_SEQUENCE = [
    "乾为天", "坤为地", "水雷屯", "山水蒙", "水天需", "天水讼", "地水师", "水地比",
    "风天小畜", "天泽履", "地天泰", "天地否", "天火同人", "火天大有", "地山谦", "雷地豫",
    "泽雷随", "山风蛊", "地泽临", "风地观", "火雷噬嗑", "山火贲", "山地剥", "地雷复",
    "天雷无妄", "山天大畜", "山雷颐", "泽风大过", "坎为水", "离为火", "泽山咸", "雷风恒",
    "天山遁", "雷天大壮", "火地晋", "地火明夷", "风火家人", "火泽睽", "水山蹇", "雷水解",
    "山泽损", "风雷益", "泽天夬", "天风姤", "泽地萃", "地风升", "泽水困", "水风井",
    "泽火革", "火风鼎", "震为雷", "艮为山", "风山渐", "雷泽归妹", "雷火丰", "火山旅",
    "巽为风", "兑为泽", "风水涣", "水泽节", "风泽中孚", "雷山小过", "水火既济", "火水未济"
]

// 八卦宫位归属及六亲地支映射
export const GUA_PALACES = {
    "乾": {
        "guas": ["乾为天", "天风姤", "天山遁", "天地否", "风地观", "山地剥", "火地晋", "火天大有"],
        "兄弟": ["申", "酉"],
        "父母": ["丑", "辰", "未", "戌"],
        "子孙": ["亥", "子"],
        "官鬼": ["巳", "午"],
        "妻财": ["寅", "卯"]
    },
    "兑": {
        "guas": ["兑为泽", "泽水困", "泽地萃", "泽山咸", "水山蹇", "地山谦", "雷山小过", "雷泽归妹"],
        "兄弟": ["申", "酉"],
        "父母": ["丑", "辰", "未", "戌"],
        "子孙": ["亥", "子"],
        "官鬼": ["巳", "午"],
        "妻财": ["寅", "卯"]
    },
    "离": {
        "guas": ["离为火", "火山旅", "火风鼎", "火水未济", "山水蒙", "风水涣", "天水讼", "天火同人"],
        "兄弟": ["巳", "午"],
        "父母": ["卯", "寅"],
        "子孙": ["丑", "辰", "未", "戌"],
        "官鬼": ["亥", "子"],
        "妻财": ["酉", "申"]
    },
    "震": {
        "guas": ["震为雷", "雷地豫", "雷水解", "雷风恒", "地风升", "水风井", "泽风大过", "泽雷随"],
        "兄弟": ["寅", "卯"],
        "父母": ["子", "亥"],
        "子孙": ["午", "巳"],
        "官鬼": ["申", "酉"],
        "妻财": ["辰", "戌", "丑", "未"]
    },
    "巽": {
        "guas": ["巽为风", "风天小畜", "风火家人", "风雷益", "天雷无妄", "火雷噬嗑", "山雷颐", "山风蛊"],
        "兄弟": ["寅", "卯"],
        "父母": ["子", "亥"],
        "子孙": ["午", "巳"],
        "官鬼": ["申", "酉"],
        "妻财": ["辰", "戌", "丑", "未"]
    },
    "坎": {
        "guas": ["坎为水", "水泽节", "水雷屯", "水火既济", "泽火革", "雷火丰", "地火明夷", "地水师"],
        "兄弟": ["子", "亥"],
        "父母": ["申", "酉"],
        "子孙": ["寅", "卯"],
        "官鬼": ["辰", "戌", "丑", "未"],
        "妻财": ["午", "巳"]
    },
    "艮": {
        "guas": ["艮为山", "山火贲", "山天大畜", "山泽损", "火泽睽", "天泽履", "风泽中孚", "风山渐"],
        "兄弟": ["辰", "戌", "丑", "未"],
        "父母": ["午", "巳"],
        "子孙": ["申", "酉"],
        "官鬼": ["寅", "卯"],
        "妻财": ["子", "亥"]
    },
    "坤": {
        "guas": ["坤为地", "地雷复", "地泽临", "地天泰", "雷天大壮", "泽天夬", "水天需", "水地比"],
        "兄弟": ["辰", "戌", "丑", "未"],
        "父母": ["午", "巳"],
        "子孙": ["申", "酉"],
        "官鬼": ["寅", "卯"],
        "妻财": ["子", "亥"]
    }
}

// 六十四卦五行属性
export const GUA_WUXING = {
    "乾为天": "金", "兑为泽": "金", "离为火": "火", "震为雷": "木",
    "巽为风": "木", "坎为水": "水", "艮为山": "土", "坤为地": "土"
}

// ==================== 六神定义 ====================
export const LIU_SHEN_NAMES = ["青龙", "朱雀", "勾陈", "螣蛇", "白虎", "玄武"]

// ==================== 天干与六神对应表（修正版） ====================
export const TIAN_GAN_TO_LIU_SHEN = {
    "甲": ["青龙", "朱雀", "勾陈", "螣蛇", "白虎", "玄武"],
    "乙": ["青龙", "朱雀", "勾陈", "螣蛇", "白虎", "玄武"],
    "丙": ["朱雀", "勾陈", "螣蛇", "白虎", "玄武", "青龙"],
    "丁": ["朱雀", "勾陈", "螣蛇", "白虎", "玄武", "青龙"],
    "戊": ["勾陈", "螣蛇", "白虎", "玄武", "青龙", "朱雀"],
    "己": ["螣蛇", "白虎", "玄武", "青龙", "朱雀", "勾陈"],
    "庚": ["白虎", "玄武", "青龙", "朱雀", "勾陈", "螣蛇"],
    "辛": ["白虎", "玄武", "青龙", "朱雀", "勾陈", "螣蛇"],
    "壬": ["玄武", "青龙", "朱雀", "勾陈", "螣蛇", "白虎"],
    "癸": ["玄武", "青龙", "朱雀", "勾陈", "螣蛇", "白虎"]
}

// ==================== 六神五行属性 ====================
export const LIU_SHEN_WUXING = {
    "青龙": "木",
    "朱雀": "火",
    "勾陈": "土",
    "螣蛇": "土",
    "白虎": "金",
    "玄武": "水"
}

// ==================== 六神吉凶属性 ====================
export const LIU_SHEN_JIXIONG = {
    "青龙": "吉",
    "朱雀": "凶",
    "勾陈": "凶",
    "螣蛇": "凶",
    "白虎": "凶",
    "玄武": "凶"
}

// ==================== 六神方位 ====================
export const LIU_SHEN_FANGWEI = {
    "青龙": "东",
    "朱雀": "南",
    "勾陈": "中",
    "螣蛇": "中",
    "白虎": "西",
    "玄武": "北"
}

// ==================== 旬空表（六十甲子） ====================
export const XUN_TABLE = [
  { leader: '甲子', kong: '戌亥' },
  { leader: '甲戌', kong: '申酉' },
  { leader: '甲申', kong: '午未' },
  { leader: '甲午', kong: '辰巳' },
  { leader: '甲辰', kong: '寅卯' },
  { leader: '甲寅', kong: '子丑' }
];

// ==================== 天干索引表 ====================
export const TIAN_GAN_INDEX = '甲乙丙丁戊己庚辛壬癸';

// ==================== 地支索引表 ====================
export const DI_ZHI_INDEX = '子丑寅卯辰巳午未申酉戌亥';

// ==================== 六神计算辅助函数 ====================

/**
 * 根据日天干获取六神顺序
 * @param {string} dayGan - 日天干
 * @returns {Array} 六神列表 [初爻, 二爻, 三爻, 四爻, 五爻, 上爻]
 */
export function getLiuShenByDayGan(dayGan) {
    return TIAN_GAN_TO_LIU_SHEN[dayGan] || [];
}

/**
 * 根据日天干和爻位获取六神
 * @param {string} dayGan - 日天干
 * @param {number} yaoPosition - 爻位 (1-6)
 * @returns {string} 六神名称
 */
export function getLiuShenForYao(dayGan, yaoPosition) {
    const liuShenList = getLiuShenByDayGan(dayGan);
    if (liuShenList.length > 0 && yaoPosition >= 1 && yaoPosition <= 6) {
        return liuShenList[yaoPosition - 1];
    }
    return "";
}

/**
 * 获取六神的五行属性
 * @param {string} liuShen - 六神名称
 * @returns {string} 五行属性
 */
export function getLiuShenWuxing(liuShen) {
    return LIU_SHEN_WUXING[liuShen] || "";
}

/**
 * 获取六神的吉凶属性
 * @param {string} liuShen - 六神名称
 * @returns {string} 吉凶属性
 */
export function getLiuShenJixiong(liuShen) {
    return LIU_SHEN_JIXIONG[liuShen] || "";
}

/**
 * 获取六神的方位
 * @param {string} liuShen - 六神名称
 * @returns {string} 方位
 */
export function getLiuShenFangwei(liuShen) {
    return LIU_SHEN_FANGWEI[liuShen] || "";
}

/**
 * 计算卦象的六神序列
 * @param {string} dayGan - 日天干
 * @returns {Array} 六神序列 [初爻, 二爻, 三爻, 四爻, 五爻, 上爻]
 */
export function calculateLiuShen(dayGan) {
    const liuShenList = getLiuShenByDayGan(dayGan);
    if (liuShenList.length === 0) {
        // 如果没有找到对应的六神列表，返回默认的六神序列
        return ["青龙", "朱雀", "勾陈", "螣蛇", "白虎", "玄武"];
    }
    return liuShenList;
}

// 根据卦码获取卦象信息
export function getGuaByCode(code) {
    for (const guaName in SIXTY_FOUR_GUA) {
        const guaInfo = SIXTY_FOUR_GUA[guaName];
        if (guaInfo.code === code) {
            return { ...guaInfo, name: guaName };
        }
    }
    return null;
}

// 根据卦名获取卦象信息
export function getGuaByName(name) {
    const guaInfo = SIXTY_FOUR_GUA[name];
    if (guaInfo) {
        return { ...guaInfo, name: name };
    }
    return null;
}

// 根据卦序获取卦象信息
export function getGuaBySequence(sequence) {
    if (sequence >= 1 && sequence <= GUA_SEQUENCE.length) {
        const guaName = GUA_SEQUENCE[sequence - 1];
        return getGuaByName(guaName);
    }
    return null;
}

// 获取指定宫位的所有卦象
export function getPalaceGuas(palace) {
    const palaceInfo = GUA_PALACES[palace];
    return palaceInfo ? palaceInfo.guas : [];
}

// 获取宫位六亲地支映射
export function getPalaceLiuQinMap(palace) {
    const palaceInfo = GUA_PALACES[palace];
    if (!palaceInfo) return {};

    const result = {};
    for (const key in palaceInfo) {
        if (key !== 'guas') {
            result[key] = palaceInfo[key];
        }
    }
    return result;
}

// 计算变卦六亲
export function calculateChangedLiuQin(originalPalace, changedBranches) {
    const palaceLiuQin = getPalaceLiuQinMap(originalPalace);
    const changedLiuQin = [];

    for (const branch of changedBranches) {
        let found = false;
        for (const qinName in palaceLiuQin) {
            const qinBranches = palaceLiuQin[qinName];
            if (qinBranches.includes(branch)) {
                changedLiuQin.push(qinName);
                found = true;
                break;
            }
        }
        if (!found) {
            changedLiuQin.push("未知"); // 容错处理
        }
    }

    return changedLiuQin;
}

// 获取所有六十四卦列表
export function listAllGuas() {
    const result = [];
    for (const name in SIXTY_FOUR_GUA) {
        result.push({ name, ...SIXTY_FOUR_GUA[name] });
    }
    return result;
}

// ==================== 伏神计算辅助函数（修复版） ====================

/**
 * 计算伏神
 * @param {string} palace - 宫位名称
 * @param {Array} currentLiuQin - 当前卦的六亲列表 [初爻, 二爻, 三爻, 四爻, 五爻, 上爻]
 * @returns {Object} 伏神信息，格式为 {爻位: {liu_qin: 六亲, branch: 地支, stem: 天干, stem_branch: 干支, position: 爻位}}
 */
export function calculateFuShen(palace, currentLiuQin) {
    // 参数验证
    if (!palace || !currentLiuQin || currentLiuQin.length !== 6) {
        console.error('伏神计算参数错误：宫位或六亲数据不完整');
        return {};
    }

    // 1. 验证本土六亲缺少哪几个
    const allLiuQin = ['兄弟', '子孙', '妻财', '官鬼', '父母'];
    const missingLiuQin = allLiuQin.filter(qin => !currentLiuQin.includes(qin));

    // 如果没有缺失的六亲，返回空对象
    if (missingLiuQin.length === 0) {
        return {};
    }

    // 2. 去所属宫的本宫卦查询缺少六亲对应的爻位
    const palaceGua = getPalaceBenGongGua(palace);
    if (!palaceGua) {
        console.error(`找不到宫位 ${palace} 对应的本宫卦`);
        return {};
    }

    // 建立本宫卦六亲到爻位的映射
    const benGongLiuQinMap = {};
    for (let i = 0; i < 6; i++) {
        const qin = palaceGua.liu_qin[i];
        const position = i + 1; // 修复：正确的爻位计算（索引0=初爻1，索引5=上爻6）
        benGongLiuQinMap[qin] = {
            position: position,
            branch: palaceGua.branches[i],
            stem: palaceGua.stems[i],
            stem_branch: palaceGua.stems[i] + palaceGua.branches[i]
        };
    }

    // 3. 返回相应的六亲
    const fuShenResult = {};

    for (const missingQin of missingLiuQin) {
        const benGongInfo = benGongLiuQinMap[missingQin];
        if (benGongInfo) {
            fuShenResult[benGongInfo.position] = {
                liu_qin: missingQin,
                branch: benGongInfo.branch,
                stem: benGongInfo.stem,
                stem_branch: benGongInfo.stem_branch,
                position: benGongInfo.position
            };
        }
    }

    return fuShenResult;
}

/**
 * 获取宫位的本宫卦信息（辅助函数）
 * @param {string} palace - 宫位名称
 * @returns {Object} 本宫卦信息
 */
function getPalaceBenGongGua(palace) {
    const palaceToBenGongMap = {
        "乾": "乾为天",
        "兑": "兑为泽",
        "离": "离为火",
        "震": "震为雷",
        "巽": "巽为风",
        "坎": "坎为水",
        "艮": "艮为山",
        "坤": "坤为地"
    };

    const benGongGuaName = palaceToBenGongMap[palace];
    if (!benGongGuaName) {
        return null;
    }

    return getGuaByName(benGongGuaName);
}

/**
 * 打印伏神信息（调试用）
 * @param {Object} fuShen - 伏神信息
 */
export function printFuShen(fuShen) {
    if (!fuShen || Object.keys(fuShen).length === 0) {
        console.log('无伏神');
        return;
    }

    console.log('伏神信息：');
    for (const position in fuShen) {
        const info = fuShen[position];
        console.log(`  第${position}爻伏神：${info.liu_qin} ${info.stem_branch}`);
    }
}